import React from "react";

import cx from "classnames";

import AttendeesFilter from "~/recordings/tabsAndFilters/AttendeeFilter";
import { SEARCH_WITH_PARAMETER_NAME } from "~/search/constants";
import DateFilter from "~/search/filters/DateFilter";

import SelectFilter from "./SelectFilter";

import styles from "./TabsAndFilters.module.css";

const TYPE_OPTIONS: { [key in string]: string } = {
	clips: "Clips",
	recordings: "Recordings",
};
export const TYPE_PARAM_NAME = "type";

const VIEWED_OPTIONS: { [key in string]: string } = {
	notViewed: "Not viewed",
	viewed: "Viewed",
};
export const VIEWED_PARAM_NAME = "viewStatus";

const ATTENDEE_TYPE_OPTIONS: { [key in string]: string } = {
	internal: "Internal only",
	external: "External only",
};
export const ATTENDEE_TYPE_PARAM_NAME = "attendeeType";

const MEETING_TYPE_OPTIONS: { [key in string]: string } = {
	organized: "Meetings I organized",
	missed: "Meetings I didn’t attend",
	notFullyAttended: "Meetings I partially attended",
};
export const MEETING_TYPE_PARAM_NAME = "meetingType";

export default function TabsAndFilters({ disabled }: { disabled: boolean }) {
	return (
		<div className={cx(styles.wrapper, { [styles.disabled]: disabled })}>
			<div className={styles.filtersAndCount}>
				<div className={styles.filtersWrapper}>
					<SelectFilter options={MEETING_TYPE_OPTIONS} paramName={MEETING_TYPE_PARAM_NAME} label="Participation" />
					<AttendeesFilter searchParam={SEARCH_WITH_PARAMETER_NAME} />
					<DateFilter />
					<SelectFilter options={ATTENDEE_TYPE_OPTIONS} paramName={ATTENDEE_TYPE_PARAM_NAME} label="Attendee type" />
					<SelectFilter options={VIEWED_OPTIONS} paramName={VIEWED_PARAM_NAME} label="View status" />
					<SelectFilter options={TYPE_OPTIONS} paramName={TYPE_PARAM_NAME} label="Video type" />
				</div>
			</div>
		</div>
	);
}
